import {
  SET_LOADING,
  SET_ERROR,
  SET_ASSESSMENTS,
  SET_ASSESSMENT_TYPES,
  SET_KPI_DATA,
  SET_STUDENTS,
  SET_STUDENTS_LOADING,
  SET_REPORT,
  SET_REPORT_LOADING,
} from './actions'

const INITIAL_STATE = {
  loading: false,
  error: null,
  assessments: [],
  pagination: {
    currentPage: 1,
    totalPages: 0,
    totalCount: 0,
    pageSize: 10,
  },
  assessmentTypes: [],
  kpiData: {
    totalCandidates: 0,
    totalAssessmentsSent: 0,
    totalAssessmentsTaken: 0,
    totalPracticeTests: 0,
  },
  students: [],
  studentsPagination: {
    currentPage: 1,
    totalPages: 0,
    totalCount: 0,
    pageSize: 10,
  },
  studentsLoading: false,
  report: null,
  reportLoading: false,
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        loading: action.data,
      }
    case SET_ERROR:
      return {
        ...state,
        error: action.data,
      }
    case SET_ASSESSMENTS:
      return {
        ...state,
        assessments: action.data.assessments,
        pagination: action.data.pagination,
      }
    case SET_ASSESSMENT_TYPES:
      return {
        ...state,
        assessmentTypes: action.data,
      }
    case SET_KPI_DATA:
      return {
        ...state,
        kpiData: action.data,
      }
    case SET_STUDENTS:
      return {
        ...state,
        students: action.data.students,
        studentsPagination: action.data.pagination,
      }
    case SET_STUDENTS_LOADING:
      return {
        ...state,
        studentsLoading: action.data,
      }
    case SET_REPORT:
      return {
        ...state,
        report: action.data,
      }
    case SET_REPORT_LOADING:
      return {
        ...state,
        reportLoading: action.data,
      }
    default:
      return state
  }
}
